import { Component, inject, Signal } from '@angular/core';
import { Store } from '@ngrx/store';
import { selectPortalVersion } from '@core/store/selectors/app-config.selectors';
import { toSignal } from '@angular/core/rxjs-interop';
import { ConsentUrlsService } from '@core/data/consent-urls/services/consent-urls.service';
import { ConsentUrlsAdapted } from '@core/data/consent-urls/models/consent-urls-adapted.model';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { CypressDirectiveModule } from '@shared/directives/cypress/cypress-directive.module';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
  selector: 'xt-portal-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule,
    CypressDirectiveModule,
    TranslocoModule,
  ],
})
export class FooterComponent {
  private store = inject(Store);
  private consentUrlsService = inject(ConsentUrlsService);

  protected portalVersion$ = this.store.pipe(selectPortalVersion);

  protected consents: Signal<ConsentUrlsAdapted> = toSignal(
    this.consentUrlsService.consents$,
  );
}
